import get from 'lodash.get';
import queryString from 'qs';

import * as CustomersActions from '../customers.actions';
import * as CustomersGridActions from './customers.grid.actions';
import { emptyArray, emptyObject } from 'ui-components/default-props/empty';
import { GridConfigStateService } from '../../../services/grid-config-state-service';
import { GridConfigUserSettingService } from '../../../services/grid-config-user-setting-service';
import { getNewStateFromPagingData, calculatePagingStats } from '../../../services/pagination-service';
import * as SellerActions from '../../../store/seller/seller.actions';
import { APP_INITIALIZATION } from '../../core/base-actions';
import * as CustomersNavActions from '../nav/customers.nav.actions';

const query = queryString.parse(window.location.search);
const filteredQuery = window.location.pathname.includes('customers') ? query : emptyObject;
const initialPagingStats = calculatePagingStats(filteredQuery.page, filteredQuery.pageSize);

const initialState = {
  searchTerm: '',
  customers: emptyArray,
  userViewConfigurations: emptyObject,
  ...initialPagingStats,
  isLoading: false,
};

const getGridData = (action) => {
  const { pageData, page, pageSize, totalCount } = action;
  const pagingStats = calculatePagingStats(page, pageSize, totalCount);

  return {
    customers: pageData.customers,
    ...pagingStats,
  };
};

const getCustomersSuccess = (state, action) => {
  const gridData = getGridData(action);
  return {
    ...state,
    ...gridData,
    isLoading: false,
  };
};

const getQuickSearchSuccess = (state, action) => {
  const { searchTerm } = action;
  const gridData = getGridData(action);
  return {
    ...state,
    ...gridData,
    isLoading: false,
    searchTerm,
  };
};

const getUserSettingsState = (state, action) => {
  const { data } = action;
  const userSettings = get(data, 'userSettings', emptyArray);
  const storedViewConfigsSettings = userSettings.filter((setting) => setting.settingName.includes('v3.customers.gridConfig'));
  return {
    ...state,
    userViewConfigurations: storedViewConfigsSettings
      ? GridConfigUserSettingService.buildUserGridConfigMap(storedViewConfigsSettings)
      : emptyObject,
  };
};

const setCustomersGridSearchTerm = (state, action) => ({
  ...state,
  searchTerm: action.searchPerformed ? state.searchTerm : undefined,
});

export const customersGrid = (state = initialState, action) => {
  const { newPage, pageSize } = action;
  switch (action.type) {
    case CustomersGridActions.CUSTOMERS_GRID_CHANGE_COLUMNS:
    case CustomersGridActions.CUSTOMERS_GRID_CHANGE_ORDERBY: {
      const { statusViewId, filterViewId, columns } = action;
      if (filterViewId === 'custom') {
        return {
          ...state,
          customViewColumnConfiguration: columns,
        };
      }
      return GridConfigStateService.updateStateViewConfig(state, statusViewId, filterViewId, columns);
    }
    case CustomersActions.GET_CUSTOMERS_REQUEST:
      return { ...state, isLoading: true };
    case CustomersActions.GET_CUSTOMERS_SUCCESS:
      return getCustomersSuccess(state, action);
    case CustomersActions.GET_CUSTOMERS_FAILURE:
      return { ...state, isLoading: false };
    case CustomersGridActions.CUSTOMERS_GRID_CHANGE_PAGE:
      return getNewStateFromPagingData(state, newPage, pageSize);
    case CustomersNavActions.CUSTOMERS_SEARCH:
      return getNewStateFromPagingData(state, action.goToPageOne ? 1 : state.page);
    case CustomersNavActions.CUSTOMERS_SET_SEARCH_PERFORMED:
      return setCustomersGridSearchTerm(state, action);
    case CustomersNavActions.CUSTOMERS_SEARCH_CLEAR_INPUT:
      return { ...state, page: 1, searchTerm: '' };
    case CustomersActions.QUICK_SEARCH_CUSTOMERS_SUCCESS:
      return getQuickSearchSuccess(state, action);
    case CustomersGridActions.CUSTOMERS_GRID_UPDATE_CUSTOM_CONFIGURATION:
      return {
        ...state,
        customViewColumnConfiguration: action.customViewColumnConfiguration,
      };
    case SellerActions.GET_SELLER_DATA_SUCCESS:
      return getUserSettingsState(state, action);
    case APP_INITIALIZATION:
      return getUserSettingsState(state, { data: action.initialData });
    default:
      return state;
  }
};

export { namespace } from './customers.grid.reducer.metadata';
